/**
 *
 * @param {Position} p1
 * @param {Position} p2
 */
export function positionEquals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
